import { Box } from '../components/Box';

export function NotFoundPage() {
    return (
        <Box title="Page not found" colorClass="bg-red">
            ◉︵◉
        </Box>
  );
}